<template>
  <ul class="tab">
    <li @click="changeIndex(0)" :class="{ 'active' : currentIndex === 0 }">导游注册</li>
    <li @click="changeIndex(1)" :class="{ 'active' : currentIndex === 1 }">单位注册</li>
  </ul>
</template>

<script>
export default {
  name: "tab",
  props: ['currentIndex'],
  methods: {
    changeIndex(index){
      this.$emit('changeIndex', index);
    }
  }
};
</script>

<style scoped lang='less'>
.tab{
  padding: 0 0.4rem;
  line-height: 1.28rem;
  display: flex;
  background: #FFFFFF;
  justify-content: space-between;
  color: #B9BED1;
  font-size: 0.426666rem;
  li{
    flex: 1;
    text-align: center;
  }
  .active{
    color: #3A3F5C;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: 0.106667rem;
      left: 50%;
      transform: translateX(-50%);
      width: 1.6rem;
      height: 0.08rem;
      background: #9D6C29;
      border-radius: 0.08rem;
    }
  }
}
</style>
